import React from "react";

export default function NewsCard({ news, lang }) {
  if (!news?.fields) return null;
  const { fields } = news;
  const title = lang === "de" ? fields.Titel : fields.Titel_EN;
  const description = lang === "de" ? fields.Beschreibung_DE : fields.Beschreibung_EN;
  const image = fields.Bild?.[0];

  return (
    <article className={`hero-news-card${image ? "" : " hero-news-card--text-only"}`}>
      {image && (
        <div className="hero-news-card__media">
          <img src={image.url} alt="" />
        </div>
      )}
      <div className="hero-news-card__body">
        <h3 className="hero-news-card__title">{title}</h3>
        <p className="hero-news-card__description">{description}</p>
        {fields.Link && (
          <a className="hero-news-card__link" href={fields.Link} target="_blank" rel="noopener noreferrer">
            {lang === "de" ? "Mehr erfahren" : "Learn more"} <span aria-hidden="true">↗</span>
          </a>
        )}
      </div>
    </article>
  );
}
